import React, { useState } from 'react';
import PropTypes from 'prop-types';

function HoverableDot({ cx, cy, payload, fill }) {
  const [hovered, setHovered] = useState(false);

  if (!payload || !Number.isInteger(payload.x)) return null;

  return (
    <circle
      cx={cx}
      cy={cy}
      r={hovered ? 5 : 3}
      fill={fill}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
    />
  );
}

HoverableDot.propTypes = {
  cx: PropTypes.number.isRequired,
  cy: PropTypes.number.isRequired,
  fill: PropTypes.string.isRequired,
  payload: PropTypes.shape({
    x: PropTypes.number.isRequired
  }).isRequired
};

export function PositiveDotRenderer(props) {
  return <HoverableDot {...props} fill="#009D19" />;
}

export function NegativeDotRenderer(props) {
  return <HoverableDot {...props} fill="#f87171" />;
}

const dotPropTypes = {
  cx: PropTypes.number,
  cy: PropTypes.number,
  payload: PropTypes.shape({
    x: PropTypes.number
  })
};

const dotDefaultProps = {
  cx: 0,
  cy: 0,
  payload: null
};

PositiveDotRenderer.propTypes = dotPropTypes;
PositiveDotRenderer.defaultProps = dotDefaultProps;

NegativeDotRenderer.propTypes = dotPropTypes;
NegativeDotRenderer.defaultProps = dotDefaultProps;
